<template>
    <div infinite-scroll-immediate="false">
        <el-row>
            <el-col :span="2" class="align-left line-height150 surgeryStatus"> <i style="background: var(--primary-color, #009688)"></i><span>已排程</span> </el-col>
            <el-col :span="2" class="align-left line-height150 surgeryStatus"> <i style="background: #f44336"></i><span>进行中</span> </el-col>
            <el-col :span="2" class="align-left line-height150 surgeryStatus"> <i style="background: #dcdfe6"></i><span>已完成</span> </el-col>
            <el-col :span="4" class="align-left line-height150 surgeryStatus"> <i style="background: #78b600"></i><span>其它(清洁时间)</span> </el-col>
            <el-col :span="4">
                <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
            </el-col>
        </el-row>
        <div class="my-calendar" :style="{ height: `${this.screenHeight2 - 100}px` }">
            <el-row type="flex" justify="space-between" class="toolbar-boxer height50 padding5">
                <el-col :span="4">
                    <item-input
                        type="select"
                        ref="selectedRoom"
                        v-show="currentView == 'W' || currentView == 'M'"
                        style="height: 32px; line-height: 32px"
                        v-model="selectedRoom"
                        :options="operationRoom"
                        placeholder="请选择手术间"
                    ></item-input>
                </el-col>
                <el-col :span="4" class="align-center">
                    <item-input type="datearraw2" v-if="currentView == 'D'" v-model="rdate"></item-input>

                    <el-row type="flex" align="center" v-else style="padding: 0 5px; height: 40px">
                        <el-col :span="2" style="display: flex; align-items: center; height: 100%">
                            <el-button icon="el-icon-back" type="primary" plain circle @click="addDate(-1)" size="small" style="padding: 5px !important"></el-button>
                        </el-col>
                        <el-col :span="20" class="padding5 padding-none-v" style="display: flex; align-items: center; height: 100%">
                            <el-date-picker
                                ref="weekPicker"
                                style="width: 250px"
                                v-if="currentView == 'W'"
                                size="small"
                                v-model="weekValue"
                                prefix-icon=""
                                type="week"
                                :format="start + ' 至 ' + end"
                                @change="showDate"
                                :picker-options="onPicker"
                                placeholder="选择周"
                            >
                            </el-date-picker>
                            <el-date-picker style="width: 250px" size="small" v-else-if="currentView == 'M'" v-model="monthValue" prefix-icon="" type="month" format="yyyy年MM月" placeholder="选择月">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="2" style="display: flex; align-items: center; justify-content: flex-end; height: 100%">
                            <el-button icon="el-icon-right" type="primary" plain circle @click="addDate(1)" style="padding: 5px !important"></el-button>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="6" class="align-right">
                    <el-button-group>
                        <el-button :type="currentView == 'D' ? 'primary' : 'plain'" size="small" @click="handleTimelineDayBtnClick">日</el-button>
                        <el-button :type="currentView == 'W' ? 'primary' : 'plain'" size="small" @click="handleTimeGridWeekBtnClick">周</el-button>
                        <el-button :type="currentView == 'M' ? 'primary' : 'plain'" size="small" @click="handleDayGridMonthBtnClick">月</el-button>
                    </el-button-group>
                </el-col>
            </el-row>
            <FullCalendar ref="myCalendar" :options="calendarOptions">
                <template v-slot:eventContent="arg">
                    <div v-if="arg.view.type == 'timeGridWeek'" class="padding5 padding-none-v align-left el-col el-col-24">
                        <el-row v-if="arg.event.extendedProps.isOtherEvent" class="ellipsis">
                            <el-col :span="18" class="align-left">
                                {{ arg.event.title }}
                            </el-col>
                        </el-row>
                        <el-row v-else :title="titleLabel(arg.event.extendedProps)">
                            <el-col :span="6" class="align-left">
                                {{ $moment(arg.event.start).format(`HH:mm`) }}
                            </el-col>
                            <el-col :span="18" class="align-right">
                                {{ arg.event.extendedProps.patient_name }}
                            </el-col>
                        </el-row>
                        <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                    </div>
                    <div v-else-if="arg.view.type == 'dayGridMonth'">
                        <el-row v-if="arg.event.extendedProps.isOtherEvent" class="ellipsis">
                            <el-col :span="18" class="align-left">
                                {{ arg.event.title }}
                            </el-col>
                        </el-row>
                        <el-row v-else class="ellipsis" :title="titleLabel(arg.event.extendedProps)">
                            <el-col :span="18" class="align-left overhidden">
                                {{ arg.event.extendedProps.surgeries }}
                            </el-col>
                            <el-col :span="6" class="align-center"> {{ arg.event.extendedProps.patient_name }} </el-col>
                        </el-row>
                    </div>
                    <div style="height: 97%; overflow: hidden" v-else @click="handleEventClick(arg)" @dblclick="handleEventDblClick(arg)">
                        <div v-if="arg.event.extendedProps.isOtherEvent" style="height: 100%" class="padding2 align-left el-col el-col-24" @dblclick="handleOtherEventDblClick(arg)">
                            <div :title="arg.event.title">
                                <el-row class="ellipsis" style="height: 17px">
                                    <el-col :span="24" class="align-left"> {{ $moment(arg.event.start).format(`HH:mm`) }}~{{ $moment(arg.event.end).format(`HH:mm`) }} </el-col>
                                </el-row>
                                <div class="ellipsis" style="height: 17px">{{ arg.event.title }}</div>
                                <div class="ellipsis" style="height: 17px" v-for="item in userListColumn" :key="item.key"></div>
                                <div class="ellipsis" style="height: 17px"></div>
                            </div>
                        </div>
                        <div v-else style="height: 100%" class="padding5 padding-none-v align-left el-col el-col-24">
                            <div v-if="arg.event.extendedProps.isShowEasyMode" :title="titleLabel(arg.event.extendedProps)" style="position: relative; height: 100%">
                                <div v-if="initialView == 'resourceTimelineDay'">
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">{{ $moment(arg.event.start).format(`HH:mm`) }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">台次:{{ arg.event.extendedProps.scheduled_sequence }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.patient_name }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.visit_no }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.sex }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.age }}</el-col>
                                    </el-row>
                                    <div class="ellipsis" style="height: 17px" v-for="(item, i) in userListColumn" v-show="i < userListColumn.length - 4" :key="item.key"></div>
                                </div>
                                <div v-else>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">病人:{{ arg.event.extendedProps.patient_name }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 17px">
                                        <el-col :span="24" class="align-left">手术:{{ arg.event.extendedProps.surgeries }}</el-col>
                                    </el-row>
                                </div>
                            </div>
                            <div v-else :title="titleLabel(arg.event.extendedProps)" style="position: relative; height: 100%">
                                <el-row class="ellipsis" :title="titleLabel(arg.event.extendedProps)">
                                    <el-col :span="6" class="align-left">
                                        {{ $moment(arg.event.start).format(`HH:mm`) }}
                                    </el-col>
                                    <el-col :span="6" class="align-center"> 台次：{{ arg.event.extendedProps.scheduled_sequence }} </el-col>
                                    <el-col :span="12" class="align-right">
                                        <el-tag
                                            class="align-right"
                                            :style="{
                                                color: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                                borderColor: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            >{{ arg.event.extendedProps.surgery_type }}</el-tag
                                        >
                                    </el-col>
                                </el-row>
                                <div class="ellipsis">
                                    {{ arg.event.extendedProps.patient_name }}({{ arg.event.extendedProps.sex || `--` }}/{{ arg.event.extendedProps.age || `--` }}/{{
                                        arg.event.extendedProps.visit_no
                                    }}/{{ arg.event.extendedProps.bed_no || `--` }}床)
                                </div>
                                <div class="ellipsis" v-for="item in userListColumn" :key="item.key">{{ item.label }}:{{ arg.event.extendedProps[item.prop] }}</div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:slotLabelContent="arg" v-if="initialView == 'resourceTimelineDay'">
                    <el-row>
                        <el-col :span="24" class="align-left">{{ arg.text }}</el-col>
                    </el-row>
                    <el-row style="width: 100%; height: 30%; margin-top: 25px" v-if="interval == 30">
                        <el-col :span="8" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="8" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="8" style="height: 100%"></el-col>
                    </el-row>
                    <el-row style="width: 100%; height: 30%; margin-top: 25px" v-else-if="interval == 60">
                        <el-col :span="4" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="4" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="4" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="4" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="4" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="4" style="height: 100%"></el-col> </el-row
                    ><el-row style="width: 100%; height: 30%; margin-top: 25px" v-else-if="interval == 20">
                        <el-col :span="12" style="height: 100%; border-right: 2px solid #dcdfe6"></el-col>
                        <el-col :span="12" style="height: 100%"></el-col>
                    </el-row>
                </template>
                <template v-slot:resourceLabelContent="arg">
                    <el-row class="font-size16" style="height: 22px">
                        <el-col :span="10" class="line-height20" :title="resourceLabelTitle" style="cursor: pointer">
                            {{ arg.resource.extendedProps.done }}/{{ arg.resource.extendedProps.total }}
                        </el-col>
                        <el-col :span="14" class="line-height20 align-right"> </el-col>
                    </el-row>
                    <draggable
                        v-bind="{
                            animation: 150,
                            group: { name: `room`, pull: 'clone', put: true },
                            disabled: false,
                            ghostClass: `ghost`,
                            sort: true
                        }"
                        tag="div"
                        class="align-left"
                        :component-data="getDraggleAttrs(arg.resource.id)"
                        style="line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex"
                        @remove="exchangeRoom"
                    >
                        <span class="operationRoom align-center" :span="24" :id="arg.resource.id">{{ arg.resource.title }}</span>
                    </draggable>
                    <el-row v-if="arg.resource.extendedProps.anesthetist && arg.resource.extendedProps.anesthetist.length > 0">
                        <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px">麻醉医生：{{ arg.resource.extendedProps.anesthetist }}</el-col>
                    </el-row>
                    <el-row v-if="arg.resource.extendedProps.anesthetist_assistant && arg.resource.extendedProps.anesthetist_assistant.length > 0">
                        <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px">麻醉助手：{{ arg.resource.extendedProps.anesthetist_assistant }}</el-col>
                    </el-row>
                    <el-row v-if="arg.resource.extendedProps.circuit_nurse && arg.resource.extendedProps.circuit_nurse.length > 0">
                        <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px">巡回护士：{{ arg.resource.extendedProps.circuit_nurse }}</el-col>
                    </el-row>
                    <el-row v-if="arg.resource.extendedProps.equipment_nurse && arg.resource.extendedProps.equipment_nurse.length > 0">
                        <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px">器械护士：{{ arg.resource.extendedProps.equipment_nurse }}</el-col>
                    </el-row>
                </template>
                <template v-slot:moreLinkContent="arg">
                    <el-row class="ellipsis">+{{ arg.num }}更多</el-row>
                </template>
            </FullCalendar>
        </div>
        <el-dialog :title="autoScheduleTitle" :close-on-click-modal="false" :visible.sync="autoScheduleVisible" class="table-h560" width="90%">
            <ListView :datalist="autoScheduleSurgeries" :columns="autoScheduleColumnListBand" :buttons="autoScheduleButtons" @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="autoScheduleVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAutoSchedule">确 定</el-button>
            </span>
        </el-dialog>
        <cus-dialog ref="CardSetting-set" title="卡片设置" :data="cardSettingInfo" width="80%" labelWidth="200" :visible.sync="cardSettingInfo.dialogFormVisible" @confirm="SaveUserColumns">
            <el-scrollbar wrap-class="scrollbar-wrapper-x" :style="{ height: `${this.screenHeight2 - 290}px`, width: `1020px` }">
                <div style="width: 1020px">
                    <div style="float: left">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 卡片字段选择</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `200px` }">
                            <div class="config-column">
                                <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; width: 300px; height: 300px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 手术卡片设置</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `300px` }">
                            <div
                                class="padding5 padding-none-v align-left el-col el-col-24"
                                style="width: 300px; background-color: var(--primary-color, #33aba0); color: white; padding: 5px; border-radius: 10px; margin-top: 20px"
                            >
                                <el-row class="ellipsis">
                                    <el-col :span="6" class="align-left"> 时间 </el-col>
                                    <el-col :span="6" class="align-center"> 台次 </el-col>
                                    <el-col :span="12" class="align-right">
                                        <el-tag
                                            class="align-right"
                                            :style="{
                                                color: 'red',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            >急诊</el-tag
                                        >
                                        <el-button class="btnSurgeryInfocss"><font-awesome-icon :icon="['fa', 'paper-plane']"></font-awesome-icon> ></el-button>
                                    </el-col>
                                </el-row>
                                <div class="ellipsis">姓名（性别/年龄/{{ T(`fullcalendar_schedule_surgery.visit_no`) }}/床号）</div>
                                <div class="align-left" v-for="item in userListColumn" :key="item.key">{{ item.label }}</div>
                                <!-- <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                <div class="ellipsis">
                    {{ arg.event.extendedProps.diseases }}
                    <font-awesome-icon style="float: right" v-show="arg.event.extendedProps.ischecked" :icon="['fa', 'check-circle']"></font-awesome-icon>
                </div> -->
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; margin-left: 10px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 悬浮字段选择</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `200px` }">
                            <div class="config-columna">
                                <item-input type="checkboxgroup" :options="configShowColumns" v-model="user_config_showcolumns"></item-input>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; margin-left: 10px; width: 300px; height: 300px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 悬浮信息设置</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `300px` }">
                            <div
                                class="padding5 padding-none-v align-left el-col el-col-24"
                                style="width: 300px; background-color: #525252; color: white; padding: 5px; border-radius: 10px; margin-top: 20px"
                            >
                                <div class="ellipsis">姓名（性别/年龄/{{ T(`fullcalendar_schedule_surgery.visit_no`) }}/床号）</div>
                                <div class="align-left" v-for="item in userListShowColumn" :key="item.key">{{ item.label }}</div>
                                <!-- <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                <div class="ellipsis">
                    {{ arg.event.extendedProps.diseases }}
                    <font-awesome-icon style="float: right" v-show="arg.event.extendedProps.ischecked" :icon="['fa', 'check-circle']"></font-awesome-icon>
                </div> -->
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </el-scrollbar>
        </cus-dialog>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
        <!-- <CardSetting :visible.sync="cardSettingInfo.dialogFormVisible" ref="CardSetting" @RefreshConfigColumn="RefreshConfigColumn"></CardSetting> -->
    </div>
</template>
<script>
// 引入已经安装好的，项目中所需要的 FullCalendar 插件
import FullCalendar from '@fullcalendar/vue'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import scrollGridPlugin from '@fullcalendar/scrollgrid'
import zhcnLocale from '@fullcalendar/core/locales/zh-cn' // ⽀持中⽂
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import Sortable from 'sortablejs'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

export default {
    name: `UnLoginRightScheduleSurgery`,
    components: { FullCalendar, Draggable, draggable },
    props: {
        leftcheckedRows: Array
    },
    data() {
        let offset = (this.$root.ScheduleQueryDateOffset || ``).split(`,`)
        let firstOffSetDate = 0
        if (offset && offset.length == 3) {
            firstOffSetDate = offset[1] // 查询开始日期
        }
        return {
            surgeryinfopush: this.$root.SurgeryInfoPush,
            collapse: 0,
            dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            scheduling_way: 1, // 排程助手  1=按科室 2=按术者 3=按术式
            operation_ward_all: undefined,
            unScheduledLength: 0, // 待排程数量
            ScheduledLength: 0, // 已排程数量
            scheduled_list: [], // 已排程列表
            autoScheduleSurgeries: [],
            autoScheduleVisible: false,
            autoScheduleColumnListBand: [],
            cardSettingInfo: {
                data: {},
                dialogFormVisible: false
            },
            user_config_columns: [],
            user_config_showcolumns: [],
            configColumns: [],
            configShowColumns: [],
            tableName: `api_newSurgery/Schedule`,
            autoScheduleButtons: [
                {
                    // class:"is-circle",
                    label: `移除`,
                    icon: ``,
                    type: `danger`,
                    emit: `cancelAutoSchedule`,
                    permission: `default`
                }
            ],
            autoScheduleColumnList: [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true
                },

                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`apply_surgery.visit_no`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `手术医生`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    isListable: true
                }
            ],
            selectedEvents: [],
            edit: {
                dialogFormVisible: false,
                surgeryId: 0,
                isReadOnly: true,
                readOnlyExcludeColumns: [`术前诊断`, `手术助手`, `年龄`, `备注`, `麻醉医生`, `麻醉助手`, `巡回护士`, `洗手护士`, `手术时间`, `预计时长`]

            },
            rejectReasons: [],
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                emitBtnName: ``,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons

                    }
                ]
            },
            timeLineSetupInfo: null,
            interval: 0,
            initialView: ``,
            onchanged: false,
            selectedRoom: 0,
            rdate: this.$moment()
                .add(firstOffSetDate, `days`).format(`YYYY-MM-DD`),
            weekValue: ``,
            start: ``, // 起始日期
            end: ``, // 截止日期
            monthValue: ``,
            onPicker: {
                firstDayOfWeek: 1
            },
            dateFormate: `yyyy-MM-dd`,
            currentView: `D`,
            operationRoomValidation: this.$root.OperationRoomValidation,
            resourceLabelTitle: `已完成/排程总数`,
            fullScreen: false,
            calendarOptions: {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    resourceTimelinePlugin,
                    resourceTimeGridPlugin,
                    scrollGridPlugin
                ],
                // initialView: `resourceTimelineDay`,
                // initialView: `resourceTimeGridDay`,
                height: `100%`,
                initialDate: this.$moment()
                    .add(firstOffSetDate, `days`).format(`YYYY-MM-DD`),
                locale: zhcnLocale,
                handleWindowResize: true,
                dayMaxEvents: 4,
                dayMinWidth: 200,
                customButtons: {
                    title: {
                        text: `Title`,
                        click: this.handleTodayBtnClick
                    },
                    prev: {
                        text: `上一天`,
                        click: this.handlePreBtnClick
                    },
                    next: { // this overrides the next button
                        text: `下一天`,
                        click: this.handleNextBtnClick
                    },
                    today: { // this overrides the next button
                        text: `今日`,
                        click: this.handleTodayBtnClick
                    },
                    resourceTimelineDay: { // this overrides the next button
                        text: `日`,
                        click: this.handleTimelineDayBtnClick
                    }
                },
                headerToolbar: false,
                views: {
                    resourceTimelineDay: {
                        buttonText: `日`
                    }
                },
                slotMinWidth: `120`,
                snapDuration: `0:10`, // 可以拖动的最新单位
                slotLabelInterval: `0:10`,
                slotDuration: `0:30`, // 时间轴间隔
                slotMinTime: `00:00:00`, // 时间轴间隔
                slotMaxTime: `24:00:00`, // 时间轴间隔
                // scrollTime: `08:00:00`,
                resourceLabelDidMount: this.resourceLabelDidMount,
                aspectRatio: 2, // 设置日历单元格宽度与高度的比例。
                slotLabelFormat: {
                    hour: `numeric`,
                    minute: `2-digit`,
                    omitZeroMinute: false,
                    meridiem: `short`
                },
                expandRows: true,
                droppable: true,
                selectable: true,
                eventResizableFromStart: false,
                noEventsMessage: `没有手术`,
                eventOrder: `scheduled_sequence`,
                nowIndicator: true,
                resourceAreaHeaderContent: ` `,
                resourceAreaWidth: `12%`,
                resources: this.getResources,
                refetchResourcesOnNavigate: true,
                resourceOrder: `display_order`,
                drop: this.drop,
                allDaySlot: false,
                lazyFetching: false,
                eventOverlap: this.eventOverlap,
                eventSources: [
                    {
                        id: `1`,
                        events: this.getEvents,
                        eventDataTransform: this.eventDataTransform
                    },
                    {
                        id: `2`,
                        events: this.getOthers,
                        eventDataTransform: this.othersEventDataTransform
                    }
                ],
                eventDrop: this.eventDrop,
                eventResize: this.eventResize,
                defaultTimedEventDuration: `01:00`,
                forceEventDuration: false,
                schedulerLicenseKey: `0469155259-fcs-1655457743`,
                eventReceive: this.eventReceive,
                eventChange: this.eventChange,
                viewDidMount: this.viewDidMount

            },
            token: sessionStorage.getItem(`token`),
            user: this.$route.query.user,
            newuser: this.$route.query.newuser,
            isLogin: false,
            timeUnit: this.$root.SurgeryTimeUnit && this.$root.SurgeryTimeUnit == `分钟` ? `minutes` : `hours`,
            defaultCostTime: 1 // 默认计时单位 1小时
        }
    },
    created() {
        // 加载用户token
        this.loadToken().then(() => {
            this.$store.dispatch(`ADD_OtherSettingColumn`)
            this.$store.dispatch(`ADD_ExtendColumnList`)
            this.defaultCostTime = this.timeUnit == `hours` ? 1 : 60 // 此参数依赖 defaultTimedEventDuration，目前 设置的是1小时
            this.$store.dispatch(`sysuser/ADD_WORKERS`)
            this.$store.dispatch(`surgery/ADD_ANAESTHESIA_METHOD`)
            this.$store.dispatch(`ADD_SECTION`)
            this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)

            this.$store.dispatch(`localip/LOAD_LOCAL_IP`).then(data => {
                this.loadWorkStation()
            })
            this.LoadUserColumns()
            this.LoadTimeLineSetupData()
        })
    },
    mounted() {
        this.$nextTick(() => {
            let calendar = this.$refs.myCalendar.getApi()
            calendar.refetchResources()
            calendar.refetchEvents()
        })
    },
    computed: {
        ...mapGetters([`screenHeight`, `localip/ipAddress`, `operation_ward_auth`,
            `otherSettingColumn`,
            `extendColumnList`]),
        columnListLpz() {
            let list = [
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `状态`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_section`,
                    label: `科室`,
                    options: this[`section_auth`],
                    colspan: 6,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_opearting_ward`,
                    label: `手术区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_hospital_ward`,
                    label: `院区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `申请台次`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: `手术医生`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: `手术助手`,
                    width: `120`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: `巡回护士`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `select1`,
                    prop: `custom_status`,
                    label: `审核结果`,
                    width: `140`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: `器械护士`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_surgeon`,
                    label: `麻醉医生`,
                    width: `120`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `anes_assistants`,
                    label: `麻醉助手`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `infectious`,
                    label: `传染病`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `is_local_anes_val`,
                    label: `麻醉类型`,
                    isListable: true
                }
            ] // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }
            // 显示扩展动态列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            return list
        },
        listColumn() {
            let r = _.filter(this.columnListLpz, { isListable: true })
            return r
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return []
            } else if (this.user_config_columns.length == 0) {
                return []
            }
            let allcolumn = _.filter(this.listColumn, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })

            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            this.$emit(`userListColumns`, r)
            return r
        },
        userListShowColumn() {
            let that = this
            if (this.configShowColumns.length == 0) {
                return []
            } else if (this.user_config_showcolumns.length == 0) {
                return []
            }
            let allcolumn = _.filter(this.listColumn, c => {
                return _.includes(this.user_config_showcolumns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configShowColumns, { value: ac.prop })
                return i
            })

            let neworder = r.map((c, index) => {
                let obj = _.filter(that.configShowColumns, { value: c.prop })
                return {
                    isListable: c.isListable,
                    label: c.label,
                    prop: c.prop,
                    type: c.type,
                    width: c.width,
                    ordernum: obj[0] == null ? 0 : obj[0].ordernum
                }
            })
            let m = _.orderBy(neworder, function(o) {
                return o.ordernum
            })
            this.$emit(`userListShowColumns`, m)
            return r
        },
        screenHeight2() {
            return this.screenHeight
        },
        operationRoom: {
            get() {
                let data = _.filter(this.operation_ward_auth, (d) => {
                    return (d.value == this.dic_operating_ward_id)
                })
                let rooms = data[0] && data[0].operation_room
                return _.orderBy(rooms, `display_order`)
            },
            set() {}
        },
        autoScheduleTitle() {
            return `排程助手(${this.autoScheduleSurgeries.length}/${this.unScheduledLength})`
        },
        titleLabel() {
            return function(row) {
                return this.setTitleLabel(row)
            }
        }
    },
    methods: {
        loadToken() {
            if (this.newuser) {
                this.user = decodeURIComponent(window.atob(this.newuser))
            }
            return new Promise(resolve => {
                let username = this.user.split(`_`)[0]
                let password = this.user.split(`_`)[1]
                if (this.$root.PwdEncryptEnabled && this.$root.PwdEncryptEnabled == `1` && this.$root.RsaPublicKeyLogin) {
                    let encryptor = new JSEncrypt()
                    encryptor.setPublicKey(this.$root.RsaPublicKeyLogin)
                    password = encryptor.encrypt(password)
                }
                let req = this.myaxios.post(`/api/AcisSystem/Authorization/Login`, {
                    user_agent: `chrome`,
                    timestamp: new Date().getTime(),
                    data: {
                        uid: username,
                        pwd: password,
                        exp: 100000
                    }
                })
                req.then(data => {
                    this.isLogin = true
                    sessionStorage.setItem(`token`, data)
                    resolve(data)
                })
            })
        },
        loadWorkStation() {
            let that = this
            return new Promise((resolve, reject) => {
                if (!this.isLogin) {
                    resolve([])
                    return
                }

                let req = this.myaxios.get(`/api/AcisSystem/WorkstationConfig/Get?token=${that[`localip/ipAddress`]}`)
                req.then(data => {
                    if (data) {
                        this.operating_room_id = data.dic_operating_room_id
                        let req1 = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get/${data.dic_operating_room_id || 0}`)
                        req1.then(d => {
                            this.dic_operating_ward_id = (d && d.dic_operating_ward_id) || data.dic_recovery_ward_id
                        }).catch(e => {
                            console.log(e)
                        })
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        showDate() {
            let that = this

            let weekOfDay = that.$moment(this.weekValue).format(`E`)
            let firstday = that.$moment(this.weekValue).subtract(weekOfDay - 1, `days`).format(`YYYY-MM-DD`)
            let endday = that.$moment(this.weekValue).subtract(weekOfDay - 7, `days`).format(`YYYY-MM-DD`)
            this.start = firstday
            this.end = endday
        },
        addDate(prevOrNext) {
            let that = this
            if (that.currentView == `W`) {
                let prev = that.$moment(this.weekValue).subtract(-prevOrNext, `week`).startOf(`week`).format(`YYYY-MM-DD`)
                let next = that.$moment(this.weekValue).subtract(-prevOrNext, `week`).endOf(`week`).format(`YYYY-MM-DD`)
                this.weekValue = prev
                this.start = prev
                this.end = next
            }
            if (that.currentView == `M`) {
                let month = that.$moment(this.monthValue).subtract(-prevOrNext, `month`)
                this.monthValue = month
            }
        },
        setTitleLabel(row) {
            let that = this
            var title = `${row.patient_name}(${row.sex || `--`}${row.age || `--`}${row.visit_no}${row.bed_no || `--`}床)\n`
            // {{ item.label }}:{{ arg.event.extendedProps[item.prop] }}
            var columns = that.userListShowColumn

            _.each(columns, item => {
                title += `${item.label}:${row[item.prop] || ``}\n`
            })
            return title
        },
        handlePreBtnClick() {
            let calendar = this.$refs.myCalendar.getApi()
            calendar.prev()
        },
        changeClass(item) {
            if (item) {
                let calendar = this.$refs.myCalendar.getApi()
                var event = calendar.getEventById(item.id)
                if (event) {
                    var classData = []
                    if (event.classNames.length != 0) {
                        classData = event.classNames
                        if (classData.indexOf(`shine`) >= 0) {
                            // 存在要设置的样式，则不再往数组中添加；
                            return
                        }
                    }
                    classData.push(`shine`)
                    event.setProp(`classNames`, classData)
                }
            }
        },
        updateClass(item) {
            if (item) {
                let calendar = this.$refs.myCalendar.getApi()
                var event = calendar.getEventById(item.id)
                if (event) {
                    var classData = []
                    if (event.classNames.length != 0) {
                        classData = event.classNames.filter(function(classItem) {
                            return classItem != `shine`
                        })
                    }
                    event.setProp(`classNames`, classData)
                }
            }
        },
        handleNextBtnClick() {
            let calendar = this.$refs.myCalendar.getApi()
            calendar.next()
        },
        handleTodayBtnClick() {
            let calendar = this.$refs.myCalendar.getApi()
            calendar.today()
        },
        handleTimelineDayBtnClick() {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            let initialDate = calendar.getOption(`initialDate`)
            that.currentView = `D`
            that.selectedRoom = 0
            that.rdate = initialDate
            that.gettimeLineSetupInfo(that.timeLineSetupInfo)
        },
        handleTimeGridWeekBtnClick() {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            let weekOfDay = that.$moment().format(`E`)
            let firstday = that.$moment().subtract(weekOfDay - 1, `days`).format(`YYYY-MM-DD`)
            let endday = that.$moment().subtract(weekOfDay - 7, `days`).format(`YYYY-MM-DD`)
            this.weekValue = firstday
            this.start = firstday
            this.end = endday
            that.currentView = `W`
            that.selectedRoom = that.operationRoom && that.operationRoom[0].value

            let a = that.$refs.weekPicker
            console.log(a)

            calendar.changeView(`timeGridWeek`, firstday)
        },
        handleDayGridMonthBtnClick() {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            that.currentView = `M`
            this.monthValue = that.$moment().format(`YYYY-MM`)
            that.selectedRoom = that.operationRoom && that.operationRoom[0].value
            calendar.changeView(`dayGridMonth`)
        },
        gettimeLineSetupInfo(data) {
            this.timeLineSetupInfo = data
            this.interval = data.interval
            this.$nextTick(() => {
                let calendar = this.$refs.myCalendar.getApi()
                let start = data && data.available_start_time ? this.$moment(data.available_start_time).format(`HH:mm`) : `00:00:00`
                let end = data && data.available_end_time ? this.$moment(data.available_end_time).format(`HH:mm`) : `23:59:00`
                let scrollFirstTime = data && data.first_show_time ? this.$moment(data.first_show_time).format(`HH:mm`) : `08:00:00`
                let interval = ``
                this.initialView = data && data.model == 1 ? `resourceTimelineDay` : `resourceTimeGridDay`
                switch (data && data.interval) {
                case 10:
                    interval = `00:10:00`
                    break
                case 20:
                    interval = `00:20:00`
                    break
                case 30:
                    interval = `00:30:00`
                    break
                case 60:
                    interval = `1:00:00`
                    break
                default:
                    interval = `1:00:00`
                    break
                }
                calendar.setOption(`slotDuration`, interval)
                if (data && (data.interval == 60 || data.interval == 30 || data.interval == 20)) {
                    calendar.setOption(`slotMinWidth`, 120)
                } else {
                    calendar.setOption(`slotMinWidth`, 60)
                }

                calendar.setOption(`slotMinTime`, start)
                calendar.setOption(`slotMaxTime`, end)
                calendar.setOption(`scrollTime`, scrollFirstTime)
                calendar.setOption(`slotLabelInterval`, interval)
                calendar.scrollToTime(scrollFirstTime)
                let initialDate = calendar.getOption(`initialDate`)
                calendar.changeView(this.initialView, initialDate)
                calendar.refetchEvents()
            })
        },
        showChangeRoom(surgerys) {
            this.$emit(`showchangeRoom`, surgerys)
        },
        getchangeRoomSave(row, surgeryIds) {
            let that = this
            console.log(surgeryIds)
            // console.log(row)
            let currentDate = that.getCurrentDate()
            let date = that.$moment(currentDate).format(`YYYY-MM-DD`)
            if (row.status == 10) {
                // 新申请的，走新申请 调用存储过程分配手术间逻辑
                that.ScheduleSurgeries(date, row.dic_operating_room_id, surgeryIds)
            } else {
                // 已排程的走更换手术间逻辑
                that.changeRoomSave(date, row.dic_operating_room_id, row.dic_recovery_ward_id, surgeryIds)
            }
        },
        changeRoomSave(date, operatingRoomId, recoveryWardId, surgeryIds) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            // added by xiaorui,2022-04-05 ,ACIS-23414,手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
            if (surgeryIds.length > 0) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ChangeRoom?operatingRoomId=${operatingRoomId}&operatingWardId=${recoveryWardId}&date=${date}`,
                    surgeryIds
                )
                req.then(data => {
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    that.$emit(`reloadLeftList`)
                    that.$message.success(`保存成功`)
                }).catch(e => {
                    that.$message.error(`更换手术间失败`)
                })
            }
        },
        showSetAnesDoctor(surgeryIds) {
            this.$emit(`showSetAnesDoctor`, surgeryIds)
        },
        setAnesDoctorSave(row) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            if (row.surgeryIds.length > 0) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/SetAnesDoctorSurgeries?plan_anes_doctor=${row.plan_anes_doctor.value}`,
                    row.surgeryIds
                )
                req.then(data => {
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    that.$emit(`reloadLeftList`)
                    that.$message.success(`保存成功`)
                }).catch(e => {
                    that.$message.error(`设置麻醉医生失败`)
                })
            }
        },
        timelinesetup() {
            this.$emit(`showTimeLineSetup`)
        },
        getEvents(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = this.$moment(fetchInfo.start).format(`YYYY-MM-DD`)
            let end = this.$moment(fetchInfo.end).format(`YYYY-MM-DD`)

            that.selectedEvents = []
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar.getApi()
                calendar.getEvents().forEach(e => {
                    e.remove()
                })
            })

            return new Promise(resolve => {
                if (!this.isLogin) {
                    resolve([])
                    return
                }
                // 获取已排程
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetCalendarScheduled?searchType=2&begin=${start}&end=${end}`)
                req.then(data1 => {
                    if (that.currentView == `W` || that.currentView == `M`) {
                        data1 = _.filter(data1, { dic_operating_room_id: that.selectedRoom })
                    }
                    let r1 = data1.map(d => {
                        d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no}/${d.dic_section} ${d.bed_no || `--`}床)</div>`
                        d.ischecked = false
                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        _.each(d, (value, key) => {
                            /* eslint valid-typeof: "error" */
                            if (typeof (d[key]) == `boolean` && key != `ischecked`) {
                                if (d[key] == true) {
                                    d[key] = `是`
                                } else {
                                    d[key] = `否`
                                }
                            } else if (d[key] && (d[key] + ``).indexOf(`/Date`) > -1) {
                                d[key] = this.$moment(d[key]).format(`YYYY/MM/DD HH:mm`)
                            } else if (key == `enum_visit_type`) {
                                if (d[key] == 1) {
                                    d[key] = `住院`
                                } else if (d[key] == 2) {
                                    d[key] = `门诊`
                                } else if (d[key] == 3) {
                                    d[key] = `体检`
                                } else {
                                    d[key] = ``
                                }
                            }
                        })

                        return d
                    })
                    that.scheduled_list = r1
                    console.log(`getEvents拿到${r1.length}个Event了`)
                    console.log(r1)
                    resolve(r1)
                })
            })
        },
        getOthers(fetchInfo, successCallback, failureCallback) {
            let that = this
            let s = this.$moment(fetchInfo.start).format(`YYYY-MM-DD`)
            let end = this.$moment(fetchInfo.end).format(`YYYY-MM-DD`)

            return new Promise(resolve => {
                if (!this.isLogin) {
                    resolve([])
                    return
                }
                let req = that.myaxios.get(`/api/AcisSystem/OtherSchedule/GetByDateRange?begin=${s}&end=${end}`)
                req.then(data => {
                    let allEvents = []
                    let startDate = this.$moment(fetchInfo.start)
                    let endDate = this.$moment(fetchInfo.end)
                    let starttmp = startDate

                    while (starttmp < endDate) {
                        let start = this.$moment(starttmp).format(`YYYY-MM-DD`)
                        _.forEach(data, function(item) {
                            if (item.repeat_mode == 1) {
                                let startday = that.$moment(item.effective_start_time).format(`YYYY-MM-DD`)
                                if (start != startday) {
                                    return
                                }
                            }

                            if (item.repeat_mode == 3 || item.repeat_mode == 4) {
                                let firstday = that.$moment(item.effective_start_time).format(`YYYY-MM-DD`)
                                let endday = that.$moment(item.effective_end_time).format(`YYYY-MM-DD`)
                                if (start < firstday || start > endday) {
                                    return
                                }

                                if (item.repeat_mode == 4) {
                                    if (item.repeat_value != null) {
                                        let weekdays = item.repeat_value.split(`,`).map(d => parseInt(d))
                                        let currentDay = that.$moment(starttmp).day()
                                        if (_.indexOf(weekdays, currentDay) == -1) {
                                            return
                                        }
                                    }
                                }
                            }

                            if (item.dic_operatingroom_ids != null) {
                                let operatingroomIds = item.dic_operatingroom_ids.split(`,`).map(d => parseInt(d))
                                let startTime = null
                                let endTime = null
                                _.forEach(operatingroomIds, function(roomId) {
                                    let tmpstart = that.$moment(item.start_time).format(`HH:mm`)
                                    startTime = that.$moment(start + ` ` + tmpstart).format(`YYYY-MM-DD HH:mm`)
                                    let tmpend = that.$moment(item.end_time).format(`HH:mm`)
                                    endTime = that.$moment(start + ` ` + tmpend).format(`YYYY-MM-DD HH:mm`)

                                    let c = {
                                        id: item.id,
                                        title: item.name,
                                        groupId: item.id,
                                        is_limit_time: item.is_limit_time,
                                        effective_start_time: that.$moment(item.effective_start_time).format(`YYYY-MM-DD HH:mm`),
                                        effective_end_time: that.$moment(item.effective_end_time).format(`YYYY-MM-DD HH:mm`),
                                        start_time: startTime,
                                        end_time: endTime,
                                        roomId: roomId,
                                        isOtherEvent: true
                                    }
                                    allEvents.push(c)
                                })
                            }
                        })
                        starttmp = starttmp.add(1, `days`)
                    }

                    console.log(`getOthers拿到${data.length}个Event了`)
                    if (that.currentView == `W` || that.currentView == `M`) {
                        allEvents = _.filter(allEvents, { roomId: that.selectedRoom })
                    }
                    console.log(allEvents)
                    resolve(allEvents)
                }).catch(e => {
                })
            })
        },
        eventDataTransform(eventData) {
            let that = this
            console.log(`eventDataTransform`)

            let bgcolor = ``
            let color = ``
            let editable = false
            switch (eventData.enum_surgery_status) {
            case 20:
                bgcolor = `var(--primary-color, #009688)`
                color = `#ffffff`
                editable = true
                break
            case 30:
                bgcolor = `#f44336`
                color = `#ffffff`
                editable = false
                break
            case 40:
                bgcolor = `#dcdfe6`
                color = `#333333`
                editable = false
                break
            default:
                bgcolor = `#dcdfe6`
                color = `#333333`
                editable = false
            }

            let start = ``
            let end = ``
            if (that.currentView == `M` || that.currentView == `W`) {
                editable = false
            }
            if (that.currentView == `M`) {
                start = that.$moment(eventData.plan_time).format(`YYYY-MM-DD`)
                end = start
            } else {
                let calendar = this.$refs.myCalendar.getApi()
                start = that.$moment(eventData.plan_time).format(`YYYY-MM-DD HH:mm:00`)
                end = that.$moment(eventData.plan_time).add(eventData.cost_time, that.timeUnit).format(`YYYY-MM-DD HH:mm:00`)
                let costTime = 0
                if (eventData.cost_time && eventData.cost_time > 0) {
                    costTime = eventData.cost_time
                } else {
                    // 获取默认时长
                    costTime = that.defaultCostTime
                }

                // 按分钟直接返回分钟数 按小时 *60
                let longMins = that.timeUnit == `minutes` ? costTime : _.round(costTime * 60)

                let slotDuration = calendar.getOption(`slotDuration`)
                let interval = 0
                switch (slotDuration) {
                case `00:10:00`:
                    interval = 10
                    break
                case `00:20:00`:
                    interval = 20
                    break
                case `00:30:00`:
                    interval = 30
                    break
                case `1:00:00`:
                    interval = 60
                    break
                default:
                    interval = 60
                    break
                }

                if (longMins <= interval) {
                    eventData.isShowEasyMode = true
                } else {
                    eventData.isShowEasyMode = false
                }
            }

            // 卡片移动权限判断
            if (!that.isCardRemove) {
                editable = false
            }

            let data = {
                id: eventData.id,
                title: eventData.drag_html,
                resourceId: eventData.dic_operating_room_id,
                start: start,
                color: bgcolor,
                textColor: color,
                end: end,
                startEditable: editable,
                durationEditable: editable,
                resourceEditable: editable,
                editable: editable,
                eventInteractive: true,
                extendedProps: eventData
            } // 可以拖动、缩放
            console.log(data)
            return data
        },
        othersEventDataTransform(eventData) {
            console.log(`othersEventDataTransform`)
            let that = this
            let bgcolor = `#78b600`
            let color = `#ffffff`
            let allDay = false
            let className = ``

            if (that.currentView == `M`) {
                eventData.start_time = that.$moment(eventData.start_time).format(`YYYY-MM-DD`)
                eventData.end_time = eventData.start_time
                allDay = true
            } else {
                if (that.currentView == `D`) {
                    className = `otherEventClass`
                }
            }
            let data = {
                id: eventData.id,
                title: eventData.title,
                resourceId: eventData.roomId,
                allDay: allDay,
                start: eventData.start_time,
                end: eventData.end_time,
                color: bgcolor,
                textColor: color,
                classNames: className,
                startEditable: false,
                durationEditable: false,
                resourceEditable: false,
                editable: false,
                eventInteractive: true,
                extendedProps: eventData
            } // 可以拖动、缩放
            console.log(data)
            return data
        },
        eventMouseEnter(mouseEnterInfo) {
        },
        // resourceLabelContent: function(arg) {

        // },
        // resourceLaneContent: function(arg) {

        // },
        eventOverlap(stillEvent, movingEvent) {
            let that = this
            if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                return false
            } else {
                return true
            }
        },
        drop(dropInfo) {
        },
        getCurrentDate() {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            return calendar.getDate()
        },
        getCalendarApi() {
            let that = this
            return that.$refs.myCalendar.getApi()
        },
        getOperationRooms(date) {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Preoperative/Schedule/GetRooms`, { date: date })
                req.then(data => {
                    that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)

                    let tmp = this.operation_ward_all && this.operation_ward_all[this.dic_operating_ward_id]
                    tmp = _.orderBy(tmp, `display_order`) || []
                    let r = tmp.map(d => {
                        let c = {
                            id: d.id,
                            title: d.name,
                            done: d.done,
                            total: d.total,
                            anesthetist: d.room_setting && d.room_setting.anesthetist || ``,
                            anesthetistObj: d.room_setting && d.room_setting.anesthetistObj || null,
                            anesthetist_id: d.room_setting && d.room_setting.anesthetist_id || null,
                            anesthetist_assistant: d.room_setting && d.room_setting.anesthetist_assistant || ``,
                            anesthetist_assistant_id: d.room_setting && d.room_setting.anesthetist_assistant_id || null,
                            anesthetist_assistantsObj: d.room_setting && d.room_setting.anesthetist_assistantsObj || null,
                            surgeon_name: d.room_setting && d.room_setting.surgeon_name || ``,
                            surgeonObj: d.room_setting && d.room_setting.surgeonObj || null,
                            surgeon_id: d.room_setting && d.room_setting.surgeon_id || null,
                            dic_surgery_name: d.room_setting && d.room_setting.dic_surgery_name || ``,
                            circuit_nurse: d.room_setting && d.room_setting.circuit_nurse || ``,
                            circuit_nurse_id: d.room_setting && d.room_setting.circuit_nurse_id || null,
                            dic_operating_room: d.room_setting && d.room_setting.dic_operating_room || null,
                            dic_operating_room_id: d.room_setting && d.room_setting.dic_operating_room_id || null,
                            dic_section_id: d.room_setting && d.room_setting.dic_section_id || null,
                            dic_section_name: d.room_setting && d.room_setting.dic_section_name || null,
                            dicSectionObj: d.room_setting && d.room_setting.dicSectionObj || null,
                            display_order: d.display_order || 0,
                            equipment_nurse: d.room_setting && d.room_setting.equipment_nurse || null,
                            equipment_nurse_id: d.room_setting && d.room_setting.equipment_nurse_id || null,
                            room_setting_id: d.room_setting && d.room_setting.id || 0
                        }
                        return c
                    })
                    console.log(`拿到手术间了`)
                    console.log(r)
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getResources(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = that.$moment(fetchInfo.start).format(`YYYY/MM/DD HH:mm:00`)
            return new Promise(resolve => {
                if (!this.isLogin) {
                    resolve([])
                    return
                }
                that.getOperationRooms(start).then(data => {
                    console.log(`拿到手术间后`)
                    console.log(data)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        resourceLabelDidMount: function(arg) {
        },
        eventDrop: function(eventDropInfo) {
            let that = this
            that.onchanged = true
        },
        eventResize: function(eventResizeInfo) {
            let that = this
            that.onchanged = true
        },
        eventAdd: function(arg) {
            console.log(`eventAdd!`)
        },
        eventChange: function(arg) {
            let that = this
            if (!that.onchanged) {
                return false
            }

            let resources = arg.event.getResources()
            let newRoomId = resources && resources[0].id

            let oldResources = arg.oldEvent.getResources()
            let oldRoomId = oldResources && oldResources[0].id

            const duration = that.$moment.duration(that.$moment(arg.event.end).diff(that.$moment(arg.event.start)))
            let costTime = that.timeUnit == `minutes` ? _.round(duration.asMinutes()) : _.round(duration.asHours(), 2)
            let r = {
                oldRoomId: oldRoomId,
                newRoomId: newRoomId,
                planTime: that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm`),
                costTime: costTime
            }
            let surgeryIds = []
            surgeryIds.push(arg.event.id)
            // 获取已排程
            let req = that.myaxios.put(`api/Preoperative/Schedule/ModifySchedulePlanAndCostTime?oldRoomId=${r.oldRoomId}&newRoomId=${r.newRoomId}&planTime=${r.planTime}&costTime=${r.costTime}`, surgeryIds)
            req.then(data1 => {
                let calendar = that.$refs.myCalendar.getApi()
                that.onchanged = false
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
                that.$message.success(`手术排程调整成功`)
            })
        },
        eventReceive: function(arg) {
            let that = this
            let startDate = that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm:00`)
            let removeids = [arg.event.id]
            let resources = arg.event.getResources()
            let newRoomId = resources && resources[0].id
            // 有手术时间
            let costTime = 0
            if (arg.event.extendedProps.cost_time && arg.event.extendedProps.cost_time != 0) {
                costTime = _.round(arg.event.extendedProps.cost_time, 2)
            } else {
                costTime = that.defaultCostTime
            }

            let req1 = that.myaxios.put(
                `/api/Preoperative/Schedule/ScheduleSurgeriesByCalendar?date=${startDate}&roomId=${newRoomId}`,
                removeids
            )
            req1.then(data => {
                let r = {
                    oldRoomId: newRoomId,
                    newRoomId: newRoomId,
                    planTime: that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm`),
                    costTime: costTime
                }

                // 获取已排程
                let req = that.myaxios.put(`api/Preoperative/Schedule/ModifySchedulePlanAndCostTime?oldRoomId=${r.oldRoomId}&newRoomId=${r.newRoomId}&planTime=${r.planTime}&costTime=${r.costTime}`, removeids)
                req.then(data1 => {
                    // arg.event.remove()
                    that.$emit(`reloadLeftList`)
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    // calendar.render()
                    that.$message.success(`排程成功`)
                })
            }).catch(e => {
                that.$emit(`reloadLeftList`)
                let calendar = that.$refs.myCalendar.getApi()
                calendar.refetchResources()
                calendar.refetchEvents()
            })
        },
        viewDidMount: function(view, el) {
            window.parent.postMessage(`viewRendered`, `*`)
        },
        handleEventClick(info) { // 日程区块，单击时触发
            if (info.event.extendedProps.isOtherEvent) { return }
            var eventObj = info.event
            eventObj.setExtendedProp(`ischecked`, !eventObj.extendedProps.ischecked)
            if (eventObj.extendedProps.ischecked) {
                this.selectedEvents.push(eventObj.extendedProps)
                this.removeLeftSelectData(info.event.id)
            } else {
                _.remove(this.selectedEvents, function(item) {
                    return (item.ischecked == true && item.id == eventObj.extendedProps.id)
                })
            }
        },
        handleEventDblClick(info) {
            let that = this
            if (info.event.extendedProps.isOtherEvent) { return }
            that.edit.surgeryId = parseInt(info.event.id)
            that.edit.dialogFormVisible = true
            return false
        },
        handleOtherEventDblClick(info) {
            let that = this
            var eventObj = info.event
            that.$emit(`showEditOtherSchedule`, eventObj.id)
        },
        removeLeftSelectData(eventId) {
            let id = parseInt(eventId)
            this.$emit(`removeLeftSelectData`, id)
        },
        cancelSchedule() {
            let that = this
            console.log(that.leftcheckedRows)
            let pmise = new Promise((resolve, reject) => {
                let surgeryIds = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
                if (that.selectedEvents.length > 0) {
                    that.selectedEvents.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                }

                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择已排程手术!`)
                    return
                }

                if (surgeryIds.length > 0) {
                    return this.$confirm(`请确认是否取消排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(surgeryIds)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    that.$message.success(`请选择已排程手术!`)
                }
            })

            pmise.then(surgeryIds => {
                let reqs =
                        surgeryIds &&
                        surgeryIds.map(d => {
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d}`)
                        })
                this.myaxios
                    .all(...reqs).then(data => {
                        let allEvents = that.$refs.myCalendar.getApi().getEvents()
                        surgeryIds.forEach(sid => {
                            let surgery = _.find(allEvents, { id: sid.toString() })
                            if (surgery) {
                                surgery.remove()
                            }
                        })
                        that.selectedEvents = []
                        that.$emit(`reloadLeftList`)
                    }).catch(e => {})
            }).catch(e => { })
        },
        loadingOverruleView(btnName) {
            let that = this

            let surgeryIds = []
            if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                if (btnName == `rejectApply`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                } else {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
            }

            if (btnName == `rejectApply`) {
                that.selectedEvents.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
            }

            if (surgeryIds.length == 0) {
                this.$message.warning(`请选择需要驳回的手术!`)
                return
            }

            var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
            if (col) {
                if (this.rejectReasons && this.rejectReasons.length > 0) {
                    col.options = this.rejectReasons
                    col.type = `select`
                } else {
                    col.options = []
                    col.type = `string`
                }
            }
            this.overrule.emitBtnName = btnName
            this.overrule.dialogFormVisible = true
        },
        saveOverrule(row) {
            let that = this
            let surgeryIds = []
            if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                if (that.overrule.emitBtnName == `rejectApply`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                } else {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
            }

            if (that.overrule.emitBtnName == `rejectApply`) {
                that.selectedEvents.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
            }

            if (surgeryIds.length == 0) {
                this.$message.warning(`请选择需要驳回的手术!`)
                return
            }

            try {
                surgeryIds.map(d => {
                    let requestData = {
                        id: d,
                        visit_info: null,
                        reject_reason: row.reject_reason
                    }
                    let calendar = that.$refs.myCalendar.getApi()
                    if (that.overrule.emitBtnName == `rejectApply`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
                        req.then(data => {
                            that.$emit(`reloadLeftList`)
                            calendar.refetchEvents()
                            // 调用手术回写
                            let pushModel = {
                                surgeryId: d,
                                surgeryInfoSendType: 1
                            }
                            var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                            reps.then(data => {
                            })
                        })
                    }
                    if (that.overrule.emitBtnName == `rejectApprove`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/RejectApprove`, requestData)
                        req.then(data => {
                            that.$emit(`reloadLeftList`)
                            calendar.refetchEvents()
                        })
                    }
                })
                that.$message.success(`手术驳回成功`)
                that.overrule.dialogFormVisible = false
            } catch (e) {
                that.$message.error(`手术驳回失败`)
            }
        },
        getDraggleAttrs(id) {
            return {
                attrs: {
                    id: id
                }
            }
        },
        exchangeRoom($event) {
            let that = this
            let from = $event.from
            from.innerHTML = `<span id="${from.id}" class="operationRoom" style="">${from.innerText}</span>`
            let oldRoomId = from.id
            let to = $event.to
            let newRoomId = to.id
            let room = _.find(that.operationRoom, { value: parseInt(to.id) })
            let toName = room && room.label || ``
            to.innerHTML = `<span id="${to.id}" class="operationRoom" style="">${toName}</span>`
            console.log($event)

            let currentDate = that.getCurrentDate()
            let date = that.$moment(currentDate).format(`YYYY-MM-DD`)

            that.$confirm(`确认将 ${from.innerText} 与 ${to.innerText} 当日排程进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${oldRoomId}&roomB=${newRoomId}&date=${date}`)
                    req.then(data => {
                        let calendar = that.$refs.myCalendar.getApi()
                        calendar.refetchResources()
                        calendar.refetchEvents()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        that.$message.error(`交换失败`)
                    })
                })
                .catch(e => {})
        },
        roomDragOption(isopen) {
            return {
                animation: 0,
                group: { name: `room`, put: [`listview`, `fixed-listview`], pull: false },
                disabled: false,
                ghostClass: `ghost`,
                sort: false
            }
        },
        loadScheduleHelper(command) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            let req
            if (command == `section`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySection`, { date: schedulingDate })
                that.scheduling_way = 1
            }
            if (command == `worker`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgeon`, { date: schedulingDate })
                that.scheduling_way = 2
            }
            if (command == `surgery`) {
                req = that.myaxios.get(`/api/Preoperative/Schedule/GetAutoScheduleBySurgery`, { date: schedulingDate })
                that.scheduling_way = 3
            }
            if (command == `changeRoom`) {
                let surgerys = []
                console.log(that.leftcheckedRows)

                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgerys.push(d)
                        }
                    })
                } else {
                    that.selectedEvents.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgerys.push(d)
                        }
                    })
                }

                if (surgerys.length == 0) {
                    this.$message.warning(`请选择已排程手术`)
                    return
                }
                this.showChangeRoom(surgerys)
                return
            }
            if (command == `setAnesDoctor`) {
                let surgeryIds = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请手术`)
                    return
                }
                that.showSetAnesDoctor(surgeryIds)
                return
            }

            req.then(data => {
                that.autoScheduleSurgeries = _.filter(data, { dic_operating_ward_id: that.dic_operating_ward_id })

                // 深拷贝一个autoScheduleColumnList
                that.autoScheduleColumnListBand = _.cloneDeep(that.autoScheduleColumnList)
                if (that.scheduling_way == 2) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeon`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                } else if (that.scheduling_way == 3) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeries`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                }

                // that.autoScheduleSurgeries = data
            }).catch(e => {
                that.autoScheduleSurgeries = []
            })
            that.autoScheduleVisible = true
        },
        cancel(command) {
            let that = this
            if (command == `cancelSchedule`) {
                that.cancelSchedule()
            }
            if (command == `rejectApprove`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApply`) {
                that.loadingOverruleView(command)
            }
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        cancelAutoSchedule({ row, index }) {
            this.autoScheduleSurgeries.splice(index, 1)
        },
        confirmAutoSchedule() {
            let that = this
            if (that.autoScheduleSurgeries.length == 0) {
                this.autoScheduleVisible = false
                return
            }
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            let reqs = []
            let cms = _.groupBy(that.autoScheduleSurgeries, `dic_operating_room_id`)
            _.forEach(cms, function(value, roomId) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ScheduleSurgeriesByCalendar?date=${schedulingDate}&roomId=${roomId}`,
                    value.map(v => v.id)
                )
                reqs.push(req)
            })

            that.myaxios
                .all(...reqs)
                .then(datas => {
                    that.$message.success(`保存成功`)
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    calendar.render()
                    this.autoScheduleVisible = false
                })
                .catch(e => {
                    console.log(e)
                    that.$message.error(`保存失败`)
                })
        },
        refetch() {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            calendar.refetchResources()
            calendar.refetchEvents()
        },
        ScheduleSurgeries(schedulingDate, roomId, surgeryIds) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let req = that.myaxios.put(
                `/api/Preoperative/Schedule/ScheduleSurgeriesByTimeLines?date=${schedulingDate}&roomId=${roomId}`,
                surgeryIds
            )
            req.then(data => {
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
                that.$message.success(`保存成功`)
            })
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            calendar.refetchEvents()
        },
        showcardSetting() {
            this.cardSettingInfo.dialogFormVisible = true
            this.LoadUserColumns()
        },
        LoadTimeLineSetupData() {
            let that = this
            let req = this.myaxios.get(`/api/AcisSystem/FullCalendarTimeLineSetup/Get`)
            req.then(data => {
                that.timeLineSetupInfo = data
                that.interval = data.interval
                that.gettimeLineSetupInfo(that.timeLineSetupInfo)
            }).catch(e => {
                console.log(e)
            })
        },
        LoadUserColumns() {
            let that = this
            let req = this.myaxios.get(`/api/AcisSystem/SystemServer/GetColumnConfig`, {
                tableName: this.tableName
            })
            req.then(data => {
                let lcs = _.orderBy(that.listColumn, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                that.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, ordernum: c.display_order }
                })
                that.configShowColumns = lcs.map(c => {
                    let obj = _.filter(data, { col_name: c.prop })
                    return { value: c.prop, label: c.label, ordernum: obj[0] == null ? 0 : obj[0].show_order }
                })

                console.log(that.configShowColumns)
                that.user_config_columns = data && _.filter(data, { enabled: true }).map(d => d.col_name) || []
                that.user_config_showcolumns = data && _.filter(data, { show_hit: true }).map(d => d.col_name) || []
                that.user_config_showcolumns = _.orderBy(that.user_config_showcolumns, `show_order`)
                that.configShowColumns = _.orderBy(that.configShowColumns, `ordernum`)

                if (this.cardSettingInfo.dialogFormVisible == true) {
                    this.configColumnDrop()
                    this.configColumnDropr()
                }
            })
        },
        SaveUserColumns() {
            let that = this
            let neworder = this.configShowColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    show_order: index,
                    show_hit: _.includes(this.user_config_showcolumns, c.value),
                    table_name: this.tableName
                }
            })

            let uc = this.configColumns.map((c, index) => {
                let obj = _.filter(neworder, { col_name: c.value })
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    show_order: obj[0].show_order,
                    show_hit: _.includes(this.user_config_showcolumns, c.value),
                    table_name: this.tableName
                }
            })

            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                let calendar = that.$refs.myCalendar.getApi()
                calendar.refetchEvents()
                this.cardSettingInfo.dialogFormVisible = false
            }).catch(e => {})
        },
        configColumnDrop() {
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) { // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        configColumnDropr() {
            const tbody = document.querySelector(`.config-columna .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columnas`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) { // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configShowColumns.splice(oldIndex, 1)[0]
                    _this.configShowColumns.splice(newIndex, 0, currRow)
                    //   this.configShowColumns = _this.configShowColumns
                }
            })
        }
    },
    watch: {
        dic_operating_ward_id: function() {
            let that = this
            that.selectedRoom = that.operationRoom && that.operationRoom[0].value
            that.refetch()
        },
        selectedRoom: function() {
            let that = this
            that.refetch()
        },
        rdate: function(newData, old) {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `D`) {
                let first = this.$moment(newData).format(`YYYY-MM-DD`)
                calendar.gotoDate(first)
            }
            that.refetch()
        },
        weekValue: function(newData, old) {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `W`) {
                let weekOfDay = that.$moment(this.weekValue).format(`E`)
                let start = that.$moment(this.weekValue).subtract(weekOfDay - 1, `days`).format(`YYYY-MM-DD`)
                calendar.gotoDate(start)
            }
            that.refetch()
        },
        monthValue: function(newData, old) {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `M`) {
                let monthfirst = that.$moment(this.monthValue).format(`YYYY-MM-DD`)
                calendar.gotoDate(monthfirst)
            }
            that.refetch()
        },
        leftcheckedRows: function(newData, old) {
            let that = this
            for (let i = 0; i < newData.length; i++) {
                let isexist = _.findIndex(that.selectedEvents, function(t) {
                    return t.id == newData[i].id
                })
                if (isexist > -1) {
                    let calendar = this.$refs.myCalendar.getApi()
                    var event = calendar.getEventById(newData[i].id)
                    if (event) {
                        event.setExtendedProp(`ischecked`, false)
                    }
                    that.selectedEvents.splice(isexist, 1)
                    return
                } else {
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.getEvents().forEach(event => {
                        event.setExtendedProp(`ischecked`, false)
                    })
                    that.selectedEvents = []
                    return
                }
            }
        }
    }
}
</script>
<style lang="less">
.config-column {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}

.config-columna {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
.config-columna .el-checkbox-group .el-checkbox {
    display: table-row;
}
.overhidden{
    white-space: nowrap;
    overflow: hidden;
    text-overflow:ellipsis;
}
.my-calendar {
    margin-top: 10px;
    text-align: center;
    background: #fff;
    height:'100%'
    //padding: 10px;
    // width: 98%;
}
.fc .fc-toolbar-title {
    display: inline-block;
}

.surgeryStatus {
    width: 120px;
    display: inline-block;
    height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    // padding: 7px 8px;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        // line-height: 1;
        border-radius: 50%;
        // padding: 7px 8px;
        vertical-align: middle;
        margin-right: 10px;
    }
}
.hasSetting {
    font-size: 14px;
    cursor: pointer;
}
.btnSurgeryInfocss {
    font-size: 15px;
    border: none !important;
    background-color: #ffffff !important;
    // background-color: rgba(0, 0, 0, 0) !important;
    width: 18px;
    height: 18px;
    border-radius: 100% !important;
    color: var(--primary-color, #009688) !important;
    padding: 0 !important;
}
.btnSurgeryInfocss:hover {
    background-color: #ffffff !important;
    color: var(--primary-color, #009688) !important;
}
.fc-event-selected:after,
.fc-event:focus:after {
    content: '';
    background: rgba(0, 0, 0, 0) !important;
    border: solid 1px lightgrey;
}
.operationRoom {
    font-size: 14px;
    margin: 0 auto;
}
.btnchecked {
    float: right;
    margin-right: 4px;
    font-size: 6px !important;
    // width: 6px !important;
    // height: 6px !important;
    color: #ffffff !important;
    background-color: #108ee9 !important;
    border: 1px solid #ffffff !important;
    i {
        float: left;
    }
}

.shine {
    // animation: scaleout 3s;
    // -moz-animation: scaleout 3s; /* Firefox */
    // -webkit-animation: scaleout 3s; /* Safari and Chrome */
    // -o-animation: scaleout 3s; /* Opera */
    -webkit-animation: scaleout 2.5s infinite ease-in-out;
    animation: scaleout 2.5s infinite ease-in-out;
}
@-webkit-keyframes scaleout {
    0% {
        -webkit-transform: scale(1);
    }
    100% {
        -webkit-transform: scale(1.1);
        opacity: 0;
    }
}
@keyframes scaleout {
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
    }
    100% {
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
        opacity: 0;
    }
}
</style>
<style lang="less">
// .fc-today-button {
//     border-radius: 0px !important;
// }
// .fc-button-primary {
//     // color: #fff !important;
//     /* font-size: 18px !important; */
//     /* background-color: #4286f5 !important; */
//     background-color: #c3eeea !important;
//     border-width: 0px !important;
//     // border-radius: 100px !important;
//     // width: 60px !important;
//     // height: 40px !important;
// }
// .fc-button-primary:focus {
//     border-width: 0px !important;
// }
// .fc-button-active {
//     // -webkit-box-shadow: 0 0 0 0.2rem rgba(234, 242, 248) !important;
//     // box-shadow: 0 0 0 0.2rem rgba(234, 242, 248) !important;
//     background-color: #009688 !important;
//     border-width: 0px !important;
// }
// .fc-prev-button,
// .fc-next-button {
//     border-radius: 100px !important;
//     width: 40px !important;
//     height: 40px !important;
// }
// .fc-today-button {
//     background-color: #009688 !important;
//     border-radius: 100px !important;
// }
// .fc-button .fc-icon {
//     vertical-align: middle;
//     font-size: 1.5em;
//     color: #1e65d1;
// }
// .fc-left {
//     width: 37% !important;
//     text-align: right !important;
// }
// .fc-center {
//     width: 26% !important;
//     text-align: left !important;
//     margin-left: -502px !important;
// }
// .fc-right {
//     width: 37% !important;
//     text-align: left !important;
//     margin-left: -595px !important;
// }
.fc-timegrid-body {
    background: white !important;
}
.fc-today {
    background: white !important;
}
.fc-day-today {
    background: white !important;
}
.fc-event {
    border-radius: 4px !important;
}
// .fc-icon {
//     display: inline-block;
//     width: 1em !important;
//     height: 1em !important;
//     text-align: center !important;
//     margin-left: -2px !important;
//     margin-top: -2px !important;
// }
// .fc-time-grid .fc-slats td {
//     height: 1.9em !important;
//     border-bottom: 0 !important;
// }
// .fc th,
// .fc td {
//     border-style: solid !important;
//     border-width: 1px !important;
//     padding: 0 !important;
//     vertical-align: top !important;
//     height: 30px !important;
//     /* margin-top:5px !important; */
// }
// .fc .fc-axis {
//     vertical-align: middle !important;
//     padding: 0 4px !important;
//     white-space: nowrap !important;
//     color: #666666 !important;
// }
// .fc th,
// .fc td .fc-day-header {
//     border-style: solid !important;
//     border-width: 1px !important;
//     padding: 0 !important;
//     vertical-align: middle !important;
//     color: #333333;
//     font-weight: normal !important;
// }
// .fc th,
// .fc td .fc-widget-content {
//     height: 35px !important;
// }
// .fc-toolbar .fc-header-toolbar .fc-center .h2 {
//     font-size: 14px !important;
// }
// .fc-toolbar.fc-header-toolbar {
//     margin-bottom: 1.1em !important;
// }
// .fc-widget-header .fc-today {
//     color: #1e65d1 !important;
// }
// .fc-unthemed td.fc-today {
//     background: #ffffff !important;
// }
// .fc .fc-row {
//     border-style: solid;
//     border-width: 0;
//     background-color: #eaf2f8;
// }
// .fc-toolbar h2 {
//     font-size: 1.3em !important;
//     margin: 0 !important;
//     color: #333333 !important;
//     font-weight: normal !important;
// }
// .fc .fc-resource-timeline-divider {
//     width: 5px !important;
// }
// .timeGridWeek {
//     display: block !important;
//     height: 60px !important;
// }
.fc-resource {
    height: auto !important;
    width: auto !important;
}

.timeGridWeekHeight {
    height: 44px !important;
}
.hightColor {
    color: red;
    font: bold;
}
// .fc-timegrid-axis {
//     width: 100px !important;
// }
// .dddddddddddddddddddddddddddddddddddd {
//     width: 100px !important;
// }
// .fc-timegrid-slot-label {
//     width: 100px !important;
// }
.fc .fc-timegrid-slot {
    height: 60px !important;
}

.fc-timegrid-event {
    display: block;
    height: auto !important;
}
.fc-event-main {
    display: block;
    height: 100% !important;
}
.fc-timeline-slot-cushion {
    display: block;
    width: 100%;
    height: 100%;
    text-align: left !important;
}
.fc-col-header-cell-cushion {
    display: block;
    width: 100%;
    height: 100%;
    font-weight: normal !important;
}
.fc-timegrid-slot-label-frame {
    position: relative !important;
    top: -20px !important;
}
.rightfloatcheck {
    position: absolute;
    right: 0px;
    bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/UnLoginRightScheduleSurgery.vue